import React, { useRef, useEffect, useState } from "react";
import {
  MdCancel,
  MdClose,
  MdOutlineAccountCircle,
  MdOutlineSearch,
  MdSearch,
} from "react-icons/md";
import { AnimatePresence, motion } from "framer-motion";
import { FaPeopleGroup } from "react-icons/fa6";
import { MdAddCircleOutline } from "react-icons/md";
import { InstructorsModal } from "../UI/Modal";
import { BsFillPeopleFill } from "react-icons/bs";
import { useSelector } from "react-redux";
import Editor from "../components/Editor";
import Select from "react-select";
import { IoImagesOutline } from "react-icons/io5";
import { MdOutlineAddAPhoto } from "react-icons/md";
import { HiOutlineTrash } from "react-icons/hi2";
import { LuFilePlus2 } from "react-icons/lu";
import Button from "../UI/Button";
import ItineraryModal from "../components/ItineraryModal";
import { LuFileCheck2 } from "react-icons/lu";
import Input from "../UI/Input";

const DetailsForm = ({ formData, setFormData, salesTeam, instructors }) => {
  const [isSearchOpen, setIsSearchOpen] = React.useState(false);
  const [overview, setOverview] = useState("");
  const [eligibility, setEligibility] = useState("");
  const [addInstructorOpen, setAddInstructorOpen] = React.useState(false);
  const ref = useRef(null);
  const phoneRef = useRef(null)
  const searchRef = useRef(null);
  const storedFormData = useSelector((state) => state.formData);
  const [hosts, setHosts] = useState([]);
  const [salesRep, setSalesRep] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [chatbotSummary, setChatbotSummary] = useState("");
  const [isPDFModalOpen, setIsPDFModalOpen] = useState(false);
  const [driveLink, setDriveLink] = useState(null)
  const companyname = useSelector((state) => state.companyname);

  const handleClickOutside = (event) => {
    if (
      ref.current &&
      !ref.current.contains(event.target) &&
      searchRef.current &&
      !searchRef.current.contains(event.target)
    ) {
      setIsSearchOpen(false);
    }
  };

  const handleAddClickInstructors = (options) => {
    console.log("options", options);
    const selected = [];
    options.map((option) => {
      selected.push(option.value);
    });
    setHosts(options);
    setFormData((prevData) => ({ ...prevData, hosts: selected }));
    // setSelectedInstructors(options);
  };

  const instructorRef = useRef(null);

  const handleAddClickSales = (options) => {
    const selected = [];
    options.map((option) => {
      selected.push(option.value);
    });
    setSalesRep(options);
    setFormData((prevData) => ({ ...prevData, salesRep: selected }));
  };

  const handleAddClickCategory = (options) => {
    const selected = [];
    options.map((option) => {
      selected.push(option.label);
    });
    setSelectedCategories(options);
    setFormData((prevData) => ({ ...prevData, events_category: selected }));
  };

  const [salesOptions, setSalesOptions] = useState([]);
  const [instrutorOptions, setInstructorOptions] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);

  useEffect(() => {
    if (storedFormData?.company_people?.sales_team_mates?.length > 0) {
      const options = storedFormData.company_people.sales_team_mates?.map(
        (mate) => {
          return { value: mate.peopleid, label: mate.username };
        }
      );
      setSalesOptions(options);
    }
    if (storedFormData?.company_people?.team_mates?.length > 0) {
      const opts = storedFormData?.company_people?.team_mates?.map((mate) => {
        return { value: mate.peopleid, label: mate.username };
      });
      setInstructorOptions(opts);
    }
    if (storedFormData?.company_category?.categories?.length > 0) {
      const opts = storedFormData?.company_category?.categories?.map((cate) => {
        return { value: cate.id, label: cate.name };
      });
      setCategoryOptions(opts);
    }
  }, []);

  useEffect(() => {
    if (storedFormData?.salesRep?.length > 0) {
      console.log("sales", storedFormData?.company_people?.sales_team_mates);
      storedFormData?.salesRep?.forEach((rep) => {
        const res = storedFormData?.company_people?.sales_team_mates?.find(
          (item) => item.peopleid == rep
        );
        console.log("ressales", res);
        if (res) {
          setSalesRep((prevState) => {
            // Check if the item already exists in the state
            const exists = prevState.some(
              (item) => item.value === res.peopleid
            );
            if (!exists) {
              return [
                ...prevState,
                { label: res?.username, value: res?.peopleid },
              ];
            }
            return prevState; // Return the unchanged state if duplicate found
          });
        }
      });

      // storedFormData?.salesRep?.forEach((rep) => {
      //   const res = storedFormData?.company_people?.sales_team_mates?.find((item) => item.peopleid == rep);
      //   console.log("res", res);
      //   if(res){
      //   setSalesRep({ label: res?.username, value: res?.peopleid })
      //   }

      // });
    }

    if (storedFormData?.hosts?.length > 0) {
      console.log("ins", instructors, storedFormData.hosts);
      storedFormData?.hosts?.forEach((rep) => {
        const res = storedFormData?.company_people?.team_mates?.find(
          (item) => item.peopleid == rep
        );
        console.log("res", res);
        if (res) {
          setHosts((prevState) => {
            // Check if the item already exists in the state
            const exists = prevState.some(
              (item) => item.value === res.peopleid
            );
            if (!exists) {
              return [
                ...prevState,
                { label: res?.username, value: res?.peopleid },
              ];
            }
            return prevState; // Return the unchanged state if duplicate found
          });
        }
      });
    }

    if (storedFormData?.events_category?.length > 0) {
      storedFormData?.events_category?.forEach((cate) => {
        const res = storedFormData?.company_category?.categories?.find(
          (item) => item.name == cate
        );
        console.log("res", res);
        if (res) {
          setSelectedCategories((prevState) => {
            const exists = prevState.some((item) => item.value == res.id);
            if (!exists) {
              return [...prevState, { label: res?.name, value: res?.id }];
            }
            return prevState;
          });
        }
      });
    }

    if (storedFormData.summary_for_chatbot) {
      setChatbotSummary(storedFormData.summary_for_chatbot);
    }
  }, [storedFormData, salesTeam, instructors]);

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#f8f6f2"
        : state.isFocused
        ? "#f8f6f2"
        : "white",
      color: state.isSelected ? "white" : "black",
      cursor: "pointer",
    }),
  };

  useEffect(() => {
    if (storedFormData) {
      setOverview(storedFormData.About_Tour);
      setEligibility(storedFormData.who_for);
      // console.log("hosts",storedFormData.sales_representative)
    }
  }, [storedFormData]);

  useEffect(() => {
    setFormData((prevData) => ({
      ...prevData,
      About_Tour: overview,
      who_for: eligibility,
      summary_for_chatbot: chatbotSummary,
    }));
  }, [overview, eligibility, chatbotSummary]);

  useEffect(() => {
    console.log(salesTeam, instructors);
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, y: 0 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0 }}
        transition={{ opacity: { duration: 0.75 }, y: { duration: 0.5 } }}
      >
        <div className=" px-6 py-4 overflow-auto pb-24 flex flex-col section_gap_sm lg:gap-0">
          <div className="lg:section_padding_lg lg:pt-0 mt-4 relative grid grid-rows-1 lg:grid-cols-3 grid-cols-1">
            <h2 className="section_heading">Overview*</h2>
            <div className="col-span-2">
              <Editor defaultvalue={overview} setValue={setOverview} />
            </div>
            <input
              type="text"
              value={overview}
              required
              className="opacity-0 absolute z-0 top-40 lg:right-10"
            />
          </div>
          <div className="relative lg:section_padding_lg grid grid-rows-1 lg:grid-cols-3 grid-cols-1">
            <h2 className="section_heading">Eligibility And Prerequisites</h2>
            <div className="col-span-2">
              <Editor defaultvalue={eligibility} setValue={setEligibility} />
            </div>
            <input
              type="text"
              value={eligibility}
              className="opacity-0 absolute z-0 top-40"
            />
          </div>
          <div className="grid grid-rows-1 lg:grid-cols-3 grid-cols-1 lg:section_padding_lg">
            <h2 className="section_heading">Event PDF</h2>
            {!formData.host_event_pdf_file ? (
              <div className="bg-white col-span-2 relative rounded-xl border-2 border-[#dad3c3] border-dashed py-10 flex flex-col justify-center items-center gap-2">
                <LuFilePlus2 size={35} />
                <Button
                  handleClick={() => {
                    setIsPDFModalOpen(true);
                  }}
                  text={"Upload PDF"}
                />

                <input
                  type="file"
                  // value={coverImage?.preview}
                  // required
                  className="opacity-0 left-10 absolute top-20 pointer-events-none"
                />
              </div>
            ) : (
              <div className="col-span-2">
                <div className="flex w-full items-center justify-between px-4 py-2 rounded-xl border-2 ">
                  <div className="flex items-center gap-2">
                    <LuFileCheck2 size={20} />
                    {!(formData.host_event_pdf_file instanceof File) ? 
                    <h4 className="text-[14px] font-medium max-w-52 md:max-w-sm overflow-hidden text-ellipsis">
                      <a style={{textDecoration: 'none'}} target="_blank" className="cursor-pointer" href={formData.host_event_pdf_file}>{formData.host_event_pdf_file}</a></h4>
                    :  <h4 className="text-[14px] font-medium max-w-52 md:max-w-sm overflow-hidden text-ellipsis">{formData.host_event_pdf_file.name}</h4>}
                  </div>
                  <HiOutlineTrash
                    className="cursor-pointer"
                    size={20}
                    onClick={() => setFormData({ ...formData, host_event_pdf_file: null })}
                  />
                </div>
              </div>
            )}
          </div>
          {isPDFModalOpen && (
            <ItineraryModal
            
              setFormData={setFormData}
              isOpen={isPDFModalOpen}
              closeModal={() => setIsPDFModalOpen(false)}
            />
          )}
          {companyname == 'trove-experiences' && <div className="relative lg:section_padding_lg grid grid-rows-1 lg:grid-cols-3 grid-cols-1">
            <h2 className="section_heading">Google Drive Link</h2>
            <div className="col-span-2">
              <Input defaultValue={storedFormData.drive_link} handleChange={(e)=>{setFormData({...formData, drive_link: e.target.value})}} classes={'w-full'} placeholder="Enter Link" />
            </div>
          </div>}
           <div className="lg:section_padding_lg grid grid-rows-1 lg:grid-cols-3">
              <h2 className="section_heading">Key Contact</h2>
              <div className="col-span-2 flex gap-4">
                <Input defaultValue={storedFormData.KeyPersonName} handleChange={(e)=>{setFormData({...formData, KeyPersonName: e.target.value})}} classes={'w-full'} placeholder="Enter Name" />
                <Input defaultValue={storedFormData.KeyPersonContact} ref={phoneRef} onInvalid={e => e.target.setCustomValidity('Phone number must have 10 digits')}
onInput={e => e.target.setCustomValidity('')} minLength={10} maxLength={10} handleChange={(e)=>{setFormData({...formData, KeyPersonContact: e.target.value})}} classes={'w-full'} placeholder="10 digit WhatsApp number" />
              </div>
            </div>

          <div className="lg:block">
            <div className="lg:section_padding_lg grid grid-rows-1 lg:grid-cols-3">
              <h2 className="section_heading">Assign instructors</h2>
              <div className="col-span-2">
                <Select
                  onChange={handleAddClickInstructors}
                  ref={instructorRef}
                  value={hosts}
                  isMulti
                  isSearchable
                  options={instrutorOptions}
                  styles={customStyles}
                  menuPlacement="top"
                  classNames={{
                    control: () => "!rounded-xl !border-2 !border-[#e5e7eb]",
                  }}
                />
              </div>
            </div>
            <div className=" grid grid-rows-1 lg:grid-cols-3 lg:section_padding_lg py-8">
              <h2 className="section_heading">Assign sales</h2>
              <div className="col-span-2">
                <Select
                  onChange={handleAddClickSales}
                  value={salesRep}
                  isMulti
                  isSearchable
                  options={salesOptions}
                  menuPlacement="top"
                  classNames={{
                    control: () => "!rounded-xl !border-2 !border-[#e5e7eb]",
                  }}
                />
              </div>
            </div>
            <div className=" grid grid-rows-1 lg:grid-cols-3 lg:section_padding_lg ">
              <h2 className="section_heading">Select Categories</h2>
              <div className="col-span-2">
                <Select
                  onChange={handleAddClickCategory}
                  value={selectedCategories}
                  isMulti
                  isSearchable
                  options={categoryOptions}
                  menuPlacement="top"
                  classNames={{
                    control: () => "!rounded-xl !border-2 !border-[#e5e7eb]",
                  }}
                />
              </div>
            </div>
            <div className=" grid grid-rows-1 lg:grid-cols-3 lg:section_padding_lg py-8">
              <h2 className="section_heading flex flex-col">
                Chatbot Summary
                <span className="text-gray-500 leading-4 text-sm">
                  {" "}
                  *Max. 200 characters
                </span>
              </h2>
              <div className="col-span-2">
                <textarea
                  maxLength={200}
                  defaultValue={chatbotSummary}
                  onChange={(e) => setChatbotSummary(e.target.value)}
                  className="w-full focus:outline-none focus-visible:outline-none h-40 md:h-52 border-2 border-[#e5e7eb] rounded-xl p-4"
                />
              </div>
            </div>
          </div>
        </div>
        {addInstructorOpen && (
          <InstructorsModal
            hosts={hosts}
            instrutorOptions={instrutorOptions}
            salesOptions={salesOptions}
            salesRep={salesRep}
            handleAddClickInstructors={handleAddClickInstructors}
            handleAddClickSales={handleAddClickSales}
            closeModal={() => {
              setAddInstructorOpen(false);
            }}
          />
        )}
      </motion.div>
    </AnimatePresence>
  );
};

export default DetailsForm;
